const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:9090/api';

console.log('🌐 API Base URL:', API_BASE_URL);

const commonHeaders = {
  'Content-Type': 'application/json',
  'ngrok-skip-browser-warning': 'true', // ✅ Bypass ngrok warning
  'User-Agent': 'KanoLimaApp',          // ✅ Identificador personalizado
};

// ============================================
// SERVICIO DE CHICAS
// ============================================
export const chicaService = {
  // Obtener todas las chicas
  obtenerTodas: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/chicas`);
      if (!response.ok) {
        throw new Error('Error al obtener las chicas');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en obtenerTodas:', error);
      throw error;
    }
  },

  // Obtener chicas por tipo
  obtenerPorTipo: async (tipo) => {
    try {
      const response = await fetch(`${API_BASE_URL}/chicas/tipo/${tipo}`);
      if (!response.ok) {
        throw new Error('Error al obtener chicas por tipo');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en obtenerPorTipo:', error);
      throw error;
    }
  },

  // Obtener chicas por distrito
  obtenerPorDistrito: async (distrito) => {
    try {
      const response = await fetch(`${API_BASE_URL}/chicas/distrito/${distrito}`);
      if (!response.ok) {
        throw new Error('Error al obtener chicas por distrito');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en obtenerPorDistrito:', error);
      throw error;
    }
  },

  // Obtener chicas por rango de edad
  obtenerPorEdad: async (edadMin, edadMax) => {
    try {
      const response = await fetch(`${API_BASE_URL}/chicas/edad?edadMin=${edadMin}&edadMax=${edadMax}`);
      if (!response.ok) {
        throw new Error('Error al obtener chicas por edad');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en obtenerPorEdad:', error);
      throw error;
    }
  },

  // Obtener chicas con filtros combinados
  obtenerFiltradas: async (tipo, distrito, edadMin, edadMax) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/chicas/filtro?tipo=${tipo}&distrito=${distrito}&edadMin=${edadMin}&edadMax=${edadMax}`
      );
      if (!response.ok) {
        throw new Error('Error al obtener chicas filtradas');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en obtenerFiltradas:', error);
      throw error;
    }
  },

  // Crear una nueva chica (admin)
  crear: async (chicaData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/chicas`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(chicaData),
      });
      if (!response.ok) {
        throw new Error('Error al crear la chica');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en crear:', error);
      throw error;
    }
  },
};

// ============================================
// SERVICIO DE USUARIOS
// ============================================
export const usuarioService = {
  // Registrar un nuevo usuario
  registrar: async (usuarioData) => {
    try {
      console.log('📤 Enviando datos de registro:', usuarioData);
      
      const response = await fetch(`${API_BASE_URL}/usuarios`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(usuarioData),
      });
      
      console.log('📥 Status de respuesta:', response.status);
      
      const responseText = await response.text();
      console.log('📥 Respuesta del servidor:', responseText);
      
      if (!response.ok) {
        let errorMessage = 'Error al registrar usuario';
        try {
          const errorData = JSON.parse(responseText);
          errorMessage = errorData.message || errorData.error || JSON.stringify(errorData);
        } catch (e) {
          errorMessage = responseText || `Error ${response.status}: ${response.statusText}`;
        }
        
        console.error('❌ Error del servidor:', errorMessage);
        throw new Error(errorMessage);
      }
      
      return JSON.parse(responseText);
    } catch (error) {
      console.error('❌ Error en registrar:', error);
      throw error;
    }
  },

  // Login con DNI y password
  login: async (dni, password) => {
    try {
      console.log('📤 Intentando login con DNI:', dni);
      
      const response = await fetch(`${API_BASE_URL}/usuarios/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ dni, password }),
      });
      
      console.log('📥 Status de respuesta login:', response.status);
      
      if (response.status === 401) {
        throw new Error('Credenciales incorrectas');
      }
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Error en login:', errorText);
        throw new Error('Error al iniciar sesión');
      }
      
      const usuario = await response.json();
      console.log('✅ Login exitoso:', usuario);
      return usuario;
    } catch (error) {
      console.error('❌ Error en login:', error);
      throw error;
    }
  },

  // Obtener usuario por ID
  obtenerPorId: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/usuarios/${id}`);
      if (!response.ok) {
        throw new Error('Error al obtener usuario');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en obtenerPorId:', error);
      throw error;
    }
  },
};

// ============================================
// SERVICIO DE DISPONIBILIDAD
// ============================================
export const disponibilidadService = {
  // Obtener disponibilidad de una chica
  obtenerPorChica: async (chicaId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/disponibilidades/${chicaId}`);
      if (!response.ok) {
        throw new Error('Error al obtener disponibilidad');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en obtenerPorChica:', error);
      throw error;
    }
  },

  // Verificar si está disponible en fecha/hora específica
  verificarDisponibilidad: async (chicaId, fecha, horaInicio, horaFin) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/disponibilidades/verificar?chicaId=${chicaId}&fecha=${fecha}&horaInicio=${horaInicio}&horaFin=${horaFin}`
      );
      if (!response.ok) {
        throw new Error('Error al verificar disponibilidad');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en verificarDisponibilidad:', error);
      throw error;
    }
  },
};

// ============================================
// SERVICIO DE CITAS
// ============================================
export const citaService = {
  // Crear una nueva cita
  crear: async (citaData) => {
    try {
      console.log('📤 Creando cita:', citaData);
      const response = await fetch(`${API_BASE_URL}/citas`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(citaData),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al crear la cita');
      }
      
      const result = await response.json();
      console.log('✅ Cita creada:', result);
      return result;
    } catch (error) {
      console.error('❌ Error en crear cita:', error);
      throw error;
    }
  },

  // Obtener citas de un usuario
  obtenerPorUsuario: async (usuarioId) => {
    try {
      console.log('📋 Obteniendo citas del usuario:', usuarioId);
      const response = await fetch(`${API_BASE_URL}/citas/usuario/${usuarioId}`);
      
      if (!response.ok) {
        throw new Error('Error al obtener citas del usuario');
      }
      
      const result = await response.json();
      console.log('✅ Citas obtenidas:', result);
      return result;
    } catch (error) {
      console.error('❌ Error en obtenerPorUsuario:', error);
      throw error;
    }
  },

  // Obtener cita por código
  obtenerPorCodigo: async (codigo) => {
    try {
      const response = await fetch(`${API_BASE_URL}/citas/codigo/${codigo}`);
      if (!response.ok) {
        throw new Error('Error al obtener la cita');
      }
      return await response.json();
    } catch (error) {
      console.error('Error en obtenerPorCodigo:', error);
      throw error;
    }
  },
  
};

// ============================================
// SERVICIO DE PAGOS CON MERCADO PAGO
// ============================================
export const pagoService = {
  // Crear preferencia de pago
  crearPreferencia: async (pagoData) => {
    try {
      console.log('💳 Creando preferencia de pago:', pagoData);
      
      const response = await fetch(`${API_BASE_URL}/pagos/crear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pagoData),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al crear preferencia de pago');
      }
      
      const result = await response.json();
      console.log('✅ Preferencia creada:', result);
      return result;
    } catch (error) {
      console.error('❌ Error al crear preferencia:', error);
      throw error;
    }
  },

  // Consultar estado de pago
  consultarEstado: async (citaId) => {
    try {
      console.log('🔍 Consultando estado de pago para cita:', citaId);
      
      const response = await fetch(`${API_BASE_URL}/pagos/cita/${citaId}/estado`);
      
      if (!response.ok) {
        throw new Error('Error al consultar estado de pago');
      }
      
      const result = await response.json();
      console.log('📊 Estado del pago:', result);
      return result;
    } catch (error) {
      console.error('❌ Error al consultar estado:', error);
      throw error;
    }
  },

  // Obtener cita confirmada después del pago
  obtenerCitaConfirmada: async (citaId) => {
    try {
      console.log('📋 Obteniendo cita confirmada:', citaId);
      
      const response = await fetch(`${API_BASE_URL}/pagos/cita/${citaId}/confirmada`);
      
      if (!response.ok) {
        throw new Error('Error al obtener cita confirmada');
      }
      
      const result = await response.json();
      console.log('✅ Cita confirmada obtenida:', result);
      return result;
    } catch (error) {
      console.error('❌ Error al obtener cita confirmada:', error);
      throw error;
    }
  },
};

// ============================================
// MAPEOS Y FUNCIONES HELPER
// ============================================

// Mapeo de tipos para convertir entre frontend y backend
export const tiposMapping = {
  'GOTICA': 'gotica',
  'COSPLAYER': 'cosplayer',
  'OTAKU': 'otaku',
  'GAMER': 'gamer',
  'ADORABLE': 'adorable',
  'FITNESS': 'fitness',
  'CINEFILA': 'cinefila',
  'MILF': 'milf',
  'EXTROVERTIDA': 'extrovertida',
  'TIMIDA': 'timida',
};

// Mapeo de distritos
export const distritosMapping = {
  'MIRAFLORES': 'Miraflores',
  'LINCE': 'Lince',
  'JESUS_MARIA': 'Jesús María',
  'SAN_MIGUEL': 'San Miguel',
  'SAN_ISIDRO': 'San Isidro',
  'PUEBLO_LIBRE': 'Pueblo Libre',
  'BARRANCO': 'Barranco',
  'MAGDALENA': 'Magdalena',
  'SURCO': 'Surco',
  'SURQUILLO': 'Surquillo',
  'SAN_BORJA': 'San Borja',
};

// Función helper para convertir ChicaResponseDTO a formato del frontend
export const convertirChicaDTO = (chicaDTO) => {
  const tiposArray = chicaDTO.tipos 
    ? Array.from(chicaDTO.tipos).map(tipo => tiposMapping[tipo] || tipo.toLowerCase())
    : [];
  
  const distritosArray = chicaDTO.distritosDisponibles 
    ? Array.from(chicaDTO.distritosDisponibles)
    : [];
  
  const distritoMostrar = distritosArray.length > 0 
    ? (distritosMapping[distritosArray[0]] || distritosArray[0])
    : 'Lima';

  return {
    id: chicaDTO.id,
    nombre: chicaDTO.nombreArtistico,
    edad: chicaDTO.edad,
    distrito: distritoMostrar,
    distritosDisponibles: distritosArray.map(d => distritosMapping[d] || d),
    telefono: chicaDTO.telefono,
    tarifaHora: chicaDTO.tarifaHora,
    horasMinimas: chicaDTO.horasMinimas,
    horasMaximas: chicaDTO.horasMaximas,
    imagen: chicaDTO.imagen || `https://images.unsplash.com/photo-${Math.random()}?w=400&h=600&fit=crop`,
    tags: chicaDTO.tags || [],
    tipos: tiposArray,
    descripcion: chicaDTO.descripcion || '',
  };
};

// Función helper para convertir del frontend al formato del backend (ChicaRequestDTO)
export const convertirAChicaRequestDTO = (chicaData) => {
  const tiposSet = chicaData.tipos 
    ? chicaData.tipos.map(tipo => {
        const tipoKey = Object.keys(tiposMapping).find(
          key => tiposMapping[key] === tipo
        );
        return tipoKey || tipo.toUpperCase();
      })
    : [];

  const distritosSet = chicaData.distritosDisponibles
    ? chicaData.distritosDisponibles.map(distrito => {
        const distritoKey = Object.keys(distritosMapping).find(
          key => distritosMapping[key] === distrito
        );
        return distritoKey || distrito.toUpperCase().replace(/ /g, '_');
      })
    : [];

  return {
    nombreArtistico: chicaData.nombre,
    telefono: chicaData.telefono,
    tarifaHora: chicaData.tarifaHora,
    horasMinimas: chicaData.horasMinimas,
    horasMaximas: chicaData.horasMaximas,
    descripcion: chicaData.descripcion,
    edad: chicaData.edad,
    tipos: tiposSet,
    distritosDisponibles: distritosSet,
  };
};

// Función helper para convertir UsuarioResponseDTO
export const convertirUsuarioDTO = (usuarioDTO) => {
  return {
    id: usuarioDTO.id,
    nombreCompleto: usuarioDTO.nombreCompleto,
    dni: usuarioDTO.dni,
  };
};

export default {
  chicaService,
  usuarioService,
  disponibilidadService,
  citaService,
  pagoService, // ⬅️ Nuevo servicio agregado
};




























